<template>
  <div>
    <b-row>
      <b-col md="12">
        <b-card>
          <div slot="header">
            <strong>
              <div>고객문의 등록정보</div>
            </strong>
          </div>
          <div class="table-responsive-sm">
            <table class="table b-table table-striped">
                <tbody class="">
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">등록자</label>
                    </td>
                    <td class="" style="vertical-align:middle">{{qaDatas.user_name}}</td>
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">회원종류</label>
                    </td>
                    <td class="" style="vertical-align:middle">
                      {{qaDatas.user_auth_type != null ? (qaDatas.user_auth_type == 'normal' ? '일반회원' : '구독회원') : ''}}
                    </td>
                  </tr>

                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">등록일</label>
                    </td>
                    <td class="" style="vertical-align:middle">{{qaDatas.reg_date}}</td>
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">문의구분</label>
                    </td>
                    <td class="" style="vertical-align:middle">{{qaDatas.public_type_name}}</td>
                  </tr>

                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">이메일</label>
                    </td>
                    <td class="" style="vertical-align:middle">{{qaDatas.reg_user}}</td>
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">핸드폰번호</label>
                    </td>
                    <td class="" style="vertical-align:middle">{{qaDatas.mobile}}</td>
                  </tr>

                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">문의종류</label>
                    </td>
                    <td class="" colspan="3" style="vertical-align:middle">{{qaDatas.type_name}}</td>
                  </tr>

                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">제목</label>
                    </td>
                    <td class="" colspan="3" style="vertical-align:middle">{{qaDatas.title}}</td>
                  </tr>
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">내용</label>
                    </td>
                    <td class="" colspan="3" style="vertical-align:middle"><div v-html="qaDatas.contents"></div></td>
                  </tr>
                </tbody>
            </table>
          </div>
        </b-card>

        <b-card>
          <div slot="header">
            <strong>
              <div>고객문의 답변</div>
            </strong>
          </div>
          <div class="table-responsive-sm">
            <table class="table b-table table-striped">
                <tbody class="">
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">답변자</label>
                    </td>
                    <td class="" style="vertical-align:middle">{{qaDatas.reply_reg_user}}</td>
                  </tr>

                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">답변상태</label>
                    </td>
                    <td class="" style="vertical-align:middle">{{qaDatas.qastatus_name}}</td>
                  </tr>

                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">제목</label>
                    </td>
                    <td class="" style="vertical-align:middle">{{qaDatas.reply_title}}</td>
                  </tr>

                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">내용</label>
                    </td>
                    <td class="" style="vertical-align:middle"><div v-html="qaDatas.reply_contents"></div></td>
                  </tr>

                  <tr class="" v-if="qaDatas.public_type_code == 'user'" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">파일첨부</label>
                    </td>
                    <td class="">
                      <div v-if="qaDatas.file_originalname == null || qaDatas.file_originalname == ''">
                        <label class="col-form-label">등록된 파일이 없습니다.</label>
                      </div>
                      <div v-else class="list-group">
                        <label class="col-form-label">
                          <!-- <i :class="'fa-file-'+attachmentFile.file_extensions+'-o'" class="fa fa-2x mt-1 bg-danger"></i> -->
                          {{qaDatas.file_originalname}}
                          <p class="fileurl" style="display: none;">{{qaDatas.file_url}}</p>
                        </label>
                      </div>
                      <!-- <b-col md="6" style="margin-left:-13px">
                        <div class="list-group">
                        	<li class="list-group-item" v-for="(attachmentFile, idx) in qaDatas.attachmentFileItems" style="padding: 0px 0px 10px 10px;">
                            <label class="col-form-label">
                              <i :class="'fa-file-'+attachmentFile.file_extensions+'-o'" class="fa fa-2x mt-1 bg-danger"></i>
                              {{attachmentFile.file_originalname}} ({{attachmentFile.filesizeStr}})
                        			<p class="fileurl" style="display: none;">{{attachmentFile.file_url}}</p>
                            </label>
                          </li>
                        </div>
                      </b-col> -->
                    </td>
                  </tr>
                </tbody>
            </table>
          </div>
        </b-card>
      </b-col>
      <b-col md="12">
        <b-row style="margin-bottom:1.5em">
          <b-col sm="3" lg="4">
            &nbsp;
          </b-col>
          <b-col sm="3" lg="4">
            &nbsp;
          </b-col>
          <b-col sm="3" lg="4">
            <div style="float:right; width:70%">
              <b-row>
                <b-col md="4">
                  <b-button v-if="qaDatas.qastatus != '1' && !(qaDatas.public_type_code == 'public' && qaDatas.qastatus == '2')" variant="danger"
                            style="color:#ffffff; border-radius:5px; cursor:pointer; width:100%; border:1px solid #f42f2d; font-size:15px"
                            v-on:click="drQaDelete(qaCode)"><h5 style="margin-bottom:0px">
                              <i class="fa fa-remove"></i> 삭제</h5>
                  </b-button>
                </b-col>
                <b-col md="4">
                  <b-button v-if="!(qaDatas.public_type_code == 'public' && qaDatas.qastatus == '2')" variant="warning"
                            style="color:#ffffff; border-radius:5px; cursor:pointer; width:100%; border:1px solid #c5940d; font-size:15px"
                            v-bind:href="'#/customer/qamanager/form'"><h5 style="margin-bottom:0px">
                              <i class="fa fa-edit"></i> 등록</h5>
                  </b-button>
                </b-col>
                <b-col md="4">
                  <b-button variant="primary" style="color:#ffffff; border-radius:5px; cursor:pointer; width:100%; border:1px solid #187c9f; font-size:15px"
                            v-bind:href="'#/customer/qamanager'">
                            <i class="fa fa-list-ul"></i> 목록</h5>
                  </b-button>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import cSwitch from '../../components/Switch';
import swal from 'sweetalert2'

export default {
  components: {
    cSwitch,
  },
  data() {
    return {
      qaCode: '',
      qaPublicTypeCode: '',
      drDeleteRows: [],
      qaDatas: {
        attachmentFileItems:[],
      },
      queryParams: {
        id:''
      },
    }
  },
  watch: {},
  mounted: function() {
    var token = sessionStorage.getItem("myToken");
    var self = this;
    self.qaCode = self.$session.get('qaCode');
    self.qaPublicTypeCode = self.$session.get('qaPublicTypeCode');

    if(self.qaCode != undefined && self.qaPublicTypeCode != undefined){
      self.getDrQaData();
    }
  },
  methods: {
    // 문의 정보 조회
    getDrQaData() {
      var self = this;
      self.queryParams.id = self.qaCode;
      self.queryParams.public_type_code = self.qaPublicTypeCode;

      var token = sessionStorage.getItem("myToken");
      var param = encodeURI(JSON.stringify(self.queryParams));
      var data = new FormData();
      data.append('objs', param);

      this.$http.post('/api/select/drQaData?access_token=' + token, data, null)
        .then((result) => {
          console.log(result.data);
          self.qaDatas = result.data;
      });
    },
    drQaDelete(){
      var self = this;

      swal.fire({
        title: '답변 삭제!',
        html: "현재 고객문의의 저장된 답변</br> 모두 삭제 됩니다. 삭제하시겠습니까?",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'OK'
      }).then((swalResult) => {
        if (swalResult.value) {
          var token = sessionStorage.getItem("myToken");

          var urlPath = '';
          self.queryParams.qastatus = 1;
          self.queryParams.reply_id = self.qaDatas.reply_id;

          if(self.qaPublicTypeCode == 'user'){
            urlPath = '/delete/qaReply';
          }else if(self.qaPublicTypeCode == 'public'){
            urlPath = '/delete/qaPublicReply';
          }

          // console.log(self.queryParams);
          var param = encodeURI(JSON.stringify(self.queryParams));
          var data = new FormData();
          data.append('objs', param);

          self.$http.post('/api'+urlPath+'?access_token='+token, data, null)
            .then((result) => {
              swal.fire({
                type: 'success',
                title: '답변이 삭제되었습니다.',
                showConfirmButton: false,
                timer: 1000
              }).then(function() {
                  window.location = "#/customer/qamanager";
              });
          })
        }else{
          // cansel
        }
      })
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/views/customer/QAManagerInfo.vue